import { 
    AegOption, 
    AegRequestForm,
    AegApprovalTypeEnum,
    AegAssignToEnum,
    AegAttendanceConditionEnum,
    AegBodyBuilderNameEnum,
    AegImplementOrBodyBuilderEnum,
    AegRepairScopeEnum,
    AegRequestTypeEnum,
    AegServiceTypeEnum,
    AegStatusEnum,
    AegVehicleTypeEnum,
 } from '../../../../../models/newAEG';
import { toEnumOptions } from '../../../../../utils/aeg';

export const REQUEST_TYPE_OPTIONS = toEnumOptions(
    Object.values(AegRequestTypeEnum),
    'intl-msg:support.aeg.requestType'
);

export const APPROVAL_TYPE_OPTIONS = toEnumOptions(
    Object.values(AegApprovalTypeEnum),
    'intl-msg:support.aeg.approvalType'
);

export const VEHICLE_TYPE_OPTIONS = toEnumOptions(
    Object.values(AegVehicleTypeEnum),
    'intl-msg:support.aeg.vehicleType'
);

export const IMPLEMENT_OPTIONS = toEnumOptions(
    Object.values(AegImplementOrBodyBuilderEnum),
    'intl-msg:support.aeg.implementOrBodyBuilder'
);

export const BODY_BUILDER_OPTIONS: AegOption[] = [
    { id: AegBodyBuilderNameEnum.MARCOPOLO, label: 'Marcopolo' },
    { id: AegBodyBuilderNameEnum.CAIO, label: 'Caio' },
    { id: AegBodyBuilderNameEnum.BUSSCAR, label: 'Busscar' },
    { id: AegBodyBuilderNameEnum.COMIL, label: 'Comil' },
    { id: AegBodyBuilderNameEnum.MASCARELLO, label: 'Mascarello' },
    { id: AegBodyBuilderNameEnum.NEOBUS, label: 'Neobus' },
    { id: AegBodyBuilderNameEnum.IRIZAR_BRASIL, label: 'Irizar Brasil' },
    { id: AegBodyBuilderNameEnum.VOLARE, label: 'Volare' },
    { id: AegBodyBuilderNameEnum.INBRASP, label: 'Inbrasp' },
    { id: AegBodyBuilderNameEnum.MVI_BUS, label: 'MVI Bus' },
    { id: AegBodyBuilderNameEnum.SITCAR, label: 'Sitcar' },
    { id: AegBodyBuilderNameEnum.TECNOBUS, label: 'Tecnobus' },
    { id: AegBodyBuilderNameEnum.HELIO_CARROCERIAS, label: 'Hélio Carrocerias' },
    { id: AegBodyBuilderNameEnum.BRABUS, label: 'Brabus' },
    { id: AegBodyBuilderNameEnum.CSM_CARROCERIAS, label: 'CSM Carrocerias' },
    { id: AegBodyBuilderNameEnum.TCA_CARROCERIAS, label: 'TCA Carrocerias' },
    { id: AegBodyBuilderNameEnum.MAXIBUS, label: 'Maxibus' },
    { id: AegBodyBuilderNameEnum.GRANVIA, label: 'Granvia' },
    { id: AegBodyBuilderNameEnum.RODOVIARIO_MEYER, label: 'Rodoviário Meyer' },
    { id: AegBodyBuilderNameEnum.MCAR, label: 'MCar' },
    { id: AegBodyBuilderNameEnum.OTHERS, labelId: 'intl-msg:support.aeg.bodyBuilderName.OTHERS' },
];

export const SERVICE_TYPE_OPTIONS = toEnumOptions(
    Object.values(AegServiceTypeEnum),
    'intl-msg:support.aeg.serviceType'
);

export const SERVICE_CONDITION_OPTIONS = toEnumOptions(
    Object.values(AegAttendanceConditionEnum),
    'intl-msg:support.aeg.attendanceCondition'
);

export const NO_YES_OPTIONS: AegOption[] = [
    { id: 'NO', labelId: 'intl-msg:support.aeg.newRequest.option.yesNo.no' },
    { id: 'YES', labelId: 'intl-msg:support.aeg.newRequest.option.yesNo.yes' },
];

export const REPAIR_SCOPE_OPTIONS = toEnumOptions(
    Object.values(AegRepairScopeEnum),
    'intl-msg:support.aeg.repairScope'
);

export const MOVE_TO_OPTIONS = toEnumOptions(
    [AegStatusEnum.REQUEST_OPENING, AegStatusEnum.PENDING_ANALYSIS],
    'intl-msg:support.aeg.status'
);

export const ASSIGN_TO_OPTIONS: AegOption[] = [
    { id: AegAssignToEnum.NOBODY, labelId: 'intl-msg:support.aeg.newRequest.option.assignTo.nobody' },
    { id: AegAssignToEnum.AFTER_SALES_CONSULTANT, labelId: 'intl-msg:support.aeg.newRequest.option.assignTo.afterSalesConsultant' },
    { id: AegAssignToEnum.AT_ENGINEER, labelId: 'intl-msg:support.aeg.newRequest.option.assignTo.atEngineer' },
    { id: AegAssignToEnum.WARRANTY_ANALYST, labelId: 'intl-msg:support.aeg.newRequest.option.assignTo.warrantyAnalyst' },
    { id: AegAssignToEnum.DEALERSHIP, labelId: 'intl-msg:support.aeg.newRequest.option.assignTo.dealership' },
];

export const INITIAL_AEG_REQUEST_FORM: AegRequestForm = {
    requestType: AegRequestTypeEnum.AEG,
    approvalType: AegApprovalTypeEnum.REGIONAL,
    responsible: '',
    dn: '',
    regional: '',
    responsibleDn: '',
    phone: '',
    occurrence: '',
    chassis: '',
    licensePlate: '',
    vehicleType: '',
    customer: '',
    model: '',
    implement: '',
    implementOther: '',
    bodyBuilder: '',
    bodyBuilderOther: '',
    cargo: '',
    odometer: '',
    hourMeter: '',
    repairDate: '',
    serviceOrder: '',
    warrantyRequest: '',
    serviceType: '',
    repairTotal: 0,
    laborTotal: '',
    serviceCondition: '',
    hasThirdParty: false,
    thirdPartyServices: '',
    thirdPartyInvoiceValue: 0,
    thirdPartyInvoiceNumber: '',
    repairScope: AegRepairScopeEnum.TOTAL,
    repairPercentage: '',
    controlCode: '',
    chameVolks: '',
    breakdown: false,
    fleetComposition: '',
    lastPurchase: '',
    companies: '',
    customerComplaint: '',
    dnDiagnosis: '',
    dnJustification: '',
    moveTo: AegStatusEnum.REQUEST_OPENING,
    assignTo: '',
    attachments: [],
};

export const VEHICLE_TYPE_BY_API_VALUE: Record<string, AegVehicleTypeEnum> = {
    CAMINHÃO: AegVehicleTypeEnum.TRUCK,
    CAMINHÕES: AegVehicleTypeEnum.TRUCK,
    'CAMINHÃO EXTRA PESADO': AegVehicleTypeEnum.EXTRA_HEAVY_TRUCK,
    ÔNIBUS: AegVehicleTypeEnum.BUS,
};

export const IMPLEMENT_BY_API_VALUE: Record<string, AegImplementOrBodyBuilderEnum> = {
    'BAÚ CARGA SECA': AegImplementOrBodyBuilderEnum.DRY_CARGO_VAN,
    'BAÚ FRIGORÍFICO': AegImplementOrBodyBuilderEnum.REFRIGERATED_VAN,
    'BAÚ LONADO': AegImplementOrBodyBuilderEnum.TARPAULIN_VAN,
    'CARGA SECA': AegImplementOrBodyBuilderEnum.DRY_CARGO,
    GRANELEIRO: AegImplementOrBodyBuilderEnum.GRAIN_BODY,
    BASCULANTE: AegImplementOrBodyBuilderEnum.TIPPER,
    'PORTA CONTÊINER': AegImplementOrBodyBuilderEnum.CONTAINER_CARRIER,
    'TANQUE CARBONO': AegImplementOrBodyBuilderEnum.CARBON_TANK,
    'TANQUE INOX': AegImplementOrBodyBuilderEnum.STAINLESS_TANK,
    'TANQUE ALUMÍNIO': AegImplementOrBodyBuilderEnum.ALUMINUM_TANK,
    CANAVIEIRO: AegImplementOrBodyBuilderEnum.SUGARCANE,
    FLORESTAL: AegImplementOrBodyBuilderEnum.FORESTRY,
    'CARREGA-TUDO': AegImplementOrBodyBuilderEnum.FLATBED_ALL,
    PRANCHA: AegImplementOrBodyBuilderEnum.PLATFORM,
    CEGONHA: AegImplementOrBodyBuilderEnum.CAR_CARRIER,
    DOLLY: AegImplementOrBodyBuilderEnum.DOLLY,
    'IMPLEMENTO ESPECIAL': AegImplementOrBodyBuilderEnum.SPECIAL_IMPLEMENT,
    SIDER: AegImplementOrBodyBuilderEnum.SIDER,
    EXTENSÍVEL: AegImplementOrBodyBuilderEnum.EXTENDABLE,
    RODOTREM: AegImplementOrBodyBuilderEnum.ROAD_TRAIN,
    BITREM: AegImplementOrBodyBuilderEnum.BITREM,
    JULIETA: AegImplementOrBodyBuilderEnum.JULIETA,
    'PLATAFORMA AUTO SOCORRO': AegImplementOrBodyBuilderEnum.SELF_RESCUE_PLATFORM,
    'PORTA BOBINA': AegImplementOrBodyBuilderEnum.COIL_CARRIER,
    'TRANSPORTE DE GÁS': AegImplementOrBodyBuilderEnum.GAS_TRANSPORT,
    'TRANSPORTE DE CIMENTO': AegImplementOrBodyBuilderEnum.CEMENT_TRANSPORT,
    'TRANSPORTE DE VIDRO': AegImplementOrBodyBuilderEnum.GLASS_TRANSPORT,
    'COLETA DE LEITE': AegImplementOrBodyBuilderEnum.MILK_COLLECTION,
    'ROLL-ON/ROLL-OFF': AegImplementOrBodyBuilderEnum.ROLL_ON_ROLL_OFF,
    POLIGUINDASTE: AegImplementOrBodyBuilderEnum.POLIGUINDASTE,
    'COLETOR COMPACTADOR DE RESÍDUOS': AegImplementOrBodyBuilderEnum.WASTE_COMPACTOR,
    'COMPACTADOR DE LIXO': AegImplementOrBodyBuilderEnum.WASTE_COMPACTOR,
    BETONEIRA: AegImplementOrBodyBuilderEnum.CONCRETE_MIXER,
    'CARROCERIA DE BEBIDAS': AegImplementOrBodyBuilderEnum.BEVERAGE_BODY,
    GUINCHO: AegImplementOrBodyBuilderEnum.TOW_TRUCK,
    'TANQUE SOBRE CHASSI': AegImplementOrBodyBuilderEnum.CHASSIS_TANK,
    'UNIDADE MÓVEL': AegImplementOrBodyBuilderEnum.MOBILE_UNIT,
    'OFICINA MÓVEL': AegImplementOrBodyBuilderEnum.MOBILE_WORKSHOP,
    AMBULÂNCIA: AegImplementOrBodyBuilderEnum.AMBULANCE,
    TRAILER: AegImplementOrBodyBuilderEnum.TRAILER,
    'PORTA MÁQUINAS': AegImplementOrBodyBuilderEnum.MACHINE_CARRIER,
};
